import React from "react";
import { NavLink } from "react-router-dom";

class Title extends React.Component
{
    render()
    {
        return (
            <div className="fixedPos">

                    <div id="title">
                        Ekonkar Games
                        
                    </div>
                        <br></br>
                        <br></br>
                        
                    <div className="navBar">
                            <NavLink className="navButtons" to ="/">Home</NavLink>
                            
                            <a className="navButtons" href= '#' onClick={OpenContact} >Contact</a>


                    </div>
            </div>
        );
    }
}
export default Title;

function OpenContact()
{
    console.log('Clicked');
    window.open('mailto:developer.ekonkargames@gmail.com');
}